import { Condition, State } from "../types/ConditionContext.types";
import isConditionTrue from "./Operators.lib";

const conditionReducer = (conditions: Condition[], conditionState: State) => {
  let checkPassed = false;

  // eslint-disable-next-line consistent-return
  conditions.forEach((condition) => {
    const { type, statementId, answerId } = condition;

    const conditionStateItem = conditionState[statementId];

    if (conditionStateItem) {
      if (Array.isArray(conditionStateItem)) {
        const valueArray = conditionState[statementId];

        (valueArray as any).forEach((valueItem: any) => {
          if (isConditionTrue[type](valueItem.id, answerId)) {
            checkPassed = true;
          }
        });

        return checkPassed;
      }

      if (isConditionTrue[type](conditionState[statementId].id, answerId)) {
        checkPassed = true;
        return checkPassed;
      }
    }
  });

  return checkPassed;
};

export default conditionReducer;
